import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityLog = ({ activities }) => {
  const getActivityIcon = (type) => {
    const icons = {
      create: 'Plus',
      update: 'Edit',
      delete: 'Trash2',
      login: 'LogIn',
      logout: 'LogOut'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      create: 'var(--color-success)',
      update: 'var(--color-primary)',
      delete: 'var(--color-error)',
      login: 'var(--color-primary)',
      logout: 'var(--color-muted-foreground)'
    };
    return colors?.[type] || 'var(--color-foreground)';
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    
    if (diffMins < 1) return 'Az önce';
    if (diffMins < 60) return `${diffMins} dakika önce`;
    if (diffHours < 24) return `${diffHours} saat önce`;
    
    return date?.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Son Aktiviteler</h3>
        <Icon name="Activity" size={20} color="var(--color-muted-foreground)" />
      </div>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {activities?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Inbox" size={32} color="var(--color-muted-foreground)" className="mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">Henüz aktivite yok</p>
          </div>
        ) : (
          activities?.map((activity) => (
            <div key={activity?.id} className="flex items-start gap-3 p-3 rounded-lg hover:bg-muted/50 transition-smooth">
              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-muted flex-shrink-0">
                <Icon 
                  name={getActivityIcon(activity?.type)} 
                  size={14} 
                  color={getActivityColor(activity?.type)} 
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground line-clamp-2">{activity?.description}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-muted-foreground">{activity?.user}</span>
                  <span className="text-xs text-muted-foreground">•</span>
                  <span className="text-xs text-muted-foreground">{formatTime(activity?.timestamp)}</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ActivityLog;